import React from "react";

const AccessDenied = () => <div>403</div>;

export default AccessDenied;
